module.exports = __webpack_public_path__ + "static/media/payment-hide.71f21b8a.png";